import { INotifications, IProjectNotifications, IProjectNotificationsMention } from '@app/@introspection';
import { translate } from '@core/translate';
import { Inject } from '@rxdi/core';
import { Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { MessageNotification } from '@shared/icons';

import { DateTimeProvider } from '../../date-time/date-time.service';

export const isProjectMentionNotification = (n: INotifications) =>
  n.data.__typename === 'ProjectNotifications' && n.data.message.__typename === 'ProjectNotificationsMention';

/**
 * @customElement project-card-mention-template
 */
@Component({
  selector: 'project-card-mention-template',
  styles: [
    css`
      .spacer {
        flex: 1 3 auto;
      }
    `,
  ],
  template(this: ProjectMentionTemplateComponent) {
    const data = this.notification.data as IProjectNotifications;
    const message = data.message as IProjectNotificationsMention;

    return html`
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 10px;">${MessageNotification}</div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span>${translate('You have being mentioned inside')}</span>
            <a style="color: blue">${message.comment.card.title}</a> <span>${translate('from project')}</span>
            <a style="color: blue">${data.projectName}</a>
            ${translate('by')} <a style="color: blue">${message.by.name}</a>
            <p>"${message?.comment.value}"</p>
          </div>
          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
  },
})
export class ProjectMentionTemplateComponent extends LitElement {
  @Inject(DateTimeProvider) private dateTimeProvider: DateTimeProvider;

  @property({ type: Object })
  notification: INotifications;
}
